import request from '@/utils/request'

let HrecordsApi = {

  /*档案管理列表*/
  list(data) {
    return request._post('/shop/plus.hrecords.Index/index', data);
},

  /*档案记录*/
  log(data) {
    return request._post('/shop/plus.hrecords.Index/log', data);
},
/*添加档案管理*/
add(data) {
    return request._post('/shop/plus.hrecords.Index/add', data);
},
/*修改档案管理*/
edit(data) {
    return request._post('/shop/plus.hrecords.Index/edit', data);
},
/*删除档案管理*/
del(data) {
    return request._post('/shop/plus.hrecords.Index/del', data);
},
/*档案管理详情*/
detail(data) {
  return request._post('/shop/plus.hrecords.Index/detail', data);
},
/*档案记录详情*/
detailLog(data) {
    return request._post('/shop/plus.hrecords.Index/detailLog', data);
  },
    saveSetting(data, errorback) {
        return request._post('/shop/plus.hrecords.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.hrecords.Setting/getSetting', data, errorback);
    },
}
export default HrecordsApi;



// WEBPACK FOOTER //
// ./src/api/hrecords.js